import cx from 'classnames'
import type React from 'react'

import { SkeletonSize, SkeletonType } from '@/types'
import css from './PreviewSkeleton.module.scss'

type Props = {
  size?: SkeletonSize
  style?: React.CSSProperties
  type?: SkeletonType
}

export const PreviewSkeleton: React.FC<Props> = ({
  size = SkeletonSize.M,
  style,
  type = SkeletonType.LINE,
}) => <div className={cx(css.skeleton, css[size], css[type])} style={style} />
